import debounce from "lodash.debounce";

export default function resizableIframe() {
  function resizeIframes() {
    // eslint-disable-next-line func-names
    $('iframe').each(function() {
      // Get the iframe’s intended aspect ratio via it’s inline dimensions
      const ratio = $(this).attr('height') / $(this).attr('width')
      // Apply a CSS height that is in correct ratio to it’s current width
      $(this).css('height', $(this).width() * ratio)
    })
  }

// Pop off an initial resize when the page loads
  resizeIframes();

// Update iframes each time the window is resized
  window.addEventListener('resize', debounce(() => {
    resizeIframes()
  }, 300));
}
